import { useState, useEffect, useCallback } from "react";

interface UseCountdownOptions {
  initialCount: number;
  onCountdownEnd: () => void;
}

const useCountdown = ({
  initialCount,
  onCountdownEnd,
}: UseCountdownOptions) => {
  const [countdown, setCountdown] = useState<number>(initialCount);

  useEffect(() => {
    let countdownInterval: any;

    if (countdown > 0) {
      countdownInterval = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1);
      }, 1000);
    } else {
      onCountdownEnd(); // Callback when countdown ends
    }

    return () => {
      clearInterval(countdownInterval);
    };
  }, [countdown, onCountdownEnd]);

  const resetCountdown = useCallback((value: number) => {
    setCountdown(value);
  }, []);

  return { countdown, resetCountdown };
};

export default useCountdown;
